document.addEventListener('DOMContentLoaded', function () {
  console.log('Le script JavaScript est bien chargé');

  // Récupérer section.id via l'attribut data-section-id sur le bouton
  const btn = document.querySelector('.voir-plus-btn');
  const sectionId = btn ? btn.getAttribute('data-section-id') : null;

  if (!sectionId) {
    console.error('Erreur : section.id est manquant');
    return;
  }

  console.log("Section ID:", sectionId);

  // Créer l'overlay une seule fois (uniquement ici, pas plusieurs)
  let overlay = document.querySelector('.vp-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'vp-overlay';
    overlay.style.display = 'none'; // L'overlay est caché au départ
    overlay.style.pointerEvents = 'none'; // Empêche d'interagir avec l'overlay quand il est caché
    document.body.appendChild(overlay);
  }

  // Fonction pour mettre à jour l'état de l'overlay en fonction de la sidetab
  const updateOverlayState = () => {
    const sideTab = document.getElementById('sideTab-' + sectionId);
    if (sideTab && sideTab.classList.contains('active')) {
      overlay.style.display = 'block';
      overlay.style.pointerEvents = 'auto';  // Permet d'interagir avec l'overlay
    } else {
      overlay.style.display = 'none';
      overlay.style.pointerEvents = 'none';  // Désactive les clics sur l'overlay
    }
  };

  // Ouvrir la side-tab
  const openTab = () => {
    const sideTab = document.getElementById('sideTab-' + sectionId);
    if (sideTab) {
      sideTab.classList.add('active');


      
      
      // Mettre à jour l'état de l'overlay
      updateOverlayState();

      // Ajoute une légère temporisation pour s'assurer que l'overflow: hidden soit appliqué correctement
      setTimeout(() => {
        document.body.classList.add('no-scroll');
        document.documentElement.classList.add('no-scroll');
      }, 1);  // Le délai peut être ajusté selon les besoins
    }
  };

  // Fermer la side-tab
  const closeTab = () => {
    const sideTab = document.getElementById('sideTab-' + sectionId);
    if (sideTab) {
      sideTab.classList.remove('active');  // Ferme la sidetab

      // Ajouter un écouteur d'événement pour la fin de la transition de la sidetab
      sideTab.addEventListener('transitionend', function onTransitionEnd() {
        // Lorsque la transition est terminée, on met à jour l'état de l'overlay

        


        updateOverlayState();

        // Retirer l'événement une fois qu'il a été exécuté
        sideTab.removeEventListener('transitionend', onTransitionEnd);

        // Retirer la classe "no-scroll" après la fin de l'animation
        document.body.classList.remove('no-scroll');
        document.documentElement.classList.remove('no-scroll');
      });

      // Optionnel : Si la sidetab est déjà complètement fermée avant l'animation, on met à jour l'overlay immédiatement.
      if (!sideTab.classList.contains('active')) {
        updateOverlayState();
      }
    }
  };

  // Attendre un peu avant de chercher les éléments
  setTimeout(() => {
    const btn = document.getElementById('voirPlusBtn-' + sectionId);  // Cibler spécifiquement ce bouton
    const closeBtn = document.getElementById('closeTab-' + sectionId);

    console.log('btn', btn); // Vérifie si btn est bien trouvé
    console.log('closeBtn', closeBtn); // Vérifie si closeBtn est bien trouvé

    if (btn && closeBtn) {
      btn.addEventListener('click', openTab);  // Quand on clique sur le bouton "Voir plus"
      closeBtn.addEventListener('click', closeTab); // Quand on clique sur le bouton "Close"
      overlay.addEventListener('click', closeTab); // Ferme la sidebar si l'overlay est cliqué
    } else {
      console.error('Erreur : Impossible de lier les événements.');
    }
  }, 1); // Délai de 500ms pour laisser le temps au DOM de se mettre à jour
});
